module.exports = __webpack_public_path__ + "img/DE00471.ab0a037a.png";